import React from 'react';

export default React.createClass({
	render() {
		const { type, children } = this.props;
		return children ? <div className={'Alert Alert--'+type}>{children}</div> : null;
	}
});